import { render, staticRenderFns } from "./Canal.vue?vue&type=template&id=285d9f15&scoped=true&"
import script from "./Canal.vue?vue&type=script&lang=js&"
export * from "./Canal.vue?vue&type=script&lang=js&"
import style0 from "./Canal.vue?vue&type=style&index=0&id=285d9f15&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285d9f15",
  null
  
)

export default component.exports